import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  // FormControl,
  withStyles,
  InputLabel,
} from '@material-ui/core';

class FormInputLabel extends React.Component {
  render() {
    let { label, classes, required, align } = this.props;
    return (
      <div className={classes.formTextLabel}>
        <InputLabel
          required={required}
          className={align === 'right' ? classes.inputLabelRight : classes.inputLabelLeft}
        >
          {label}
        </InputLabel>
      </div>
    );
  }
}

const styles = (theme) => ({
  formTextLabel: {
    width: '100%',
    justifyContent: 'flex-start',
    alignitems: 'center',
    paddingTop: '20px',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '10px',
    },
  },

  inputLabelLeft: {
    color: '#4a4a4a',
  },

  inputLabelRight: {
    float: 'right',
    color: '#4a4a4a',
    [theme.breakpoints.down('xs')]: {
      float: 'left',
    },
  },
});

export const page = inject()(observer(FormInputLabel));
export default withStyles(styles, { withTheme: true })(page);
